import { Component, Input } from '@angular/core';
import { Device } from '@kion/data-models';
import {Location} from "@angular/common";

@Component({
  selector: 'kion-device-short-info',
  templateUrl: './device-short-info.component.html',
  styleUrls: ['./device-short-info.component.scss']
})
export class DeviceShortInfoComponent {
  @Input() device: Device;
  @Input() enableDeviceLink = false;

  constructor(
      private location: Location
  ) {
  }

  get deviceLink(): string {
    return this.location.prepareExternalUrl('/device-list/' + this.device.manufacturer.toLowerCase() + '/' + this.device.id);
  }
}
